<template>
  <b-card :class="{ 'mx-2': showFilters, 'm-0': !showFilters }" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            v-if="!embedded"
            cols="12"
            :md="hasSearchSlot ? 4 : 6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              :value="perPage"
              @input="$emit('per-page', $event)"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" :md="embedded ? 12 : (hasSearchSlot ? 8 : 6)">
            <div class="d-flex align-items-center justify-content-end table-search-actions">
              <slot name="search">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1 table-search-input"
                  :placeholder="$t('table.search')"
                />
              </slot>
              <button
                class="btn btn-success"
                @click="$emit('refresh-data')"
              >
                <feather-icon icon="RefreshCwIcon" size="14" />
              </button>
              <b-button
                v-if="showExport"
                variant="success"
                class="text-capitalize ml-1"
                type="button"
                :disabled="exporting"
                @click="$emit('export')"
              >
                <feather-icon icon="DownloadCloudIcon" size="15" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(dvr.name)="data">
          <slot name="cell-dvr" :item="data.item" :value="data.value">
            {{ data.value }}
          </slot>
        </template>

        <template #head(description)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(event_definition)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(event_type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_id)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(device_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(user_name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(user_id)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(panel.name)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(event_created_at)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(id_alarm)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(alarm_type)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(is_recovered)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #cell(is_recovered)="data">
          <b-badge :variant="data.item.is_recovered ? 'light-danger' : 'light-success'">
            {{ data.item.is_recovered ? $t('yes') : $t('no') }}
          </b-badge>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="(val) => $emit('update', val)"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
</template>

<script>
import { BBadge, BButton } from "bootstrap-vue";
import Pagination from "@/components/Pagination.vue";
import vSelect from "vue-select";

export default {
  props: {
    currentPage: {
      type: Number,
      require: true
    },
    dataMeta: {
      type: Object,
      require: true
    },
    fetchList: {
      type: Function,
      require: true
    },
    isSortDirDesc: {
      type: Boolean,
      require: true
    },
    perPage: {
      type: Number,
      require: true
    },
    perPageOptions: {
      type: Array,
      require: true
    },
    searchQuery: {
      type: String,
      require: true
    },
    sortBy: {
      type: String,
      require: true
    },
    tableColumns:{
      type: Array,
      require: true
    },
    totalList: {
      type: Number,
      require: true
    },
    showFilters: {
      type: Boolean,
      default: true
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    showExport: {
      type: Boolean,
      default: false
    },
    exporting: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BBadge,
    BButton,
    Pagination,
    vSelect
  },
  computed: {
    hasSearchSlot () {
      return Boolean(this.$scopedSlots['search'] || this.$slots['search'])
    }
  },
  setup () {


    return {}
  }
}
</script>

<style scoped lang="scss">
.table-search-actions {
  flex-wrap: wrap;
  row-gap: 0.5rem;
}

.table-search-input {
  flex: 1 1 0;
  min-width: 120px;
}
</style>
